import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../context/AuthContext";
import HeaderRoutes from "../HeaderRoutes/HeaderRoutes";

export default function SystemHeaderNav() {
  const { permission, pages, pagesName } = useContext(AuthContext);
  const [step, setStep] = useState();

  let groupName = Object.keys(pagesName).includes("GROUP_HEADER_TEXT")
    ? pagesName.GROUP_HEADER_TEXT
    : "Group";

  const headerLinks = [
    {
      label: "Admin Panel",
      link: "/firehouse/admin-panel",
      hide: !permission.includes("global_admin"),
    },
    // {
    //     label: "Authorities",
    //     link: "/firehouse/authorities",
    //     disable: true,
    // },
    // {
    //     label: "Integrations",
    //     link: "/firehouse/integrations",
    //     disable: true,
    // },
    // {
    //     label: "Backup and Restore",
    //     link: "/firehouse/backup",
    //     disable: true,
    // },
    // {
    //     label: "User Settings",
    //     link: "/firehouse/user-settings",
    //     disable: true,
    // },
    {
      label: "View Log",
      link: "/firehouse/view-log",
      hide: !permission.includes("Schedule_Auth"),
    },
    {
      label: "Journal Audit Log",
      link: "/firehouse/audit-log",
      hide: !permission.includes("Schedule_Auth"),
    },
    {
      label: "System variable",
      link: "/firehouse/config",
      hide: !permission.includes("global_admin"),
    },
    {
      label: "Select Options",
      link: "/firehouse/select-option",
      hide: !permission.includes("global_admin"),
    },
    {
      label: groupName + " Settings",
      link: "/firehouse/groups-settings",
      hide: !permission.includes("global_admin"),
    },
  ];

  useEffect(() => {
    let i = headerLinks.findIndex((x) => {
      return x.link == window.location.pathname;
    });
    setStep(i);

    if (document.querySelector("[href='/firehouse/view-log']")) {
      document
        .querySelector("[href='/firehouse/view-log']")
        .classList.add("RaMenuItemLink-active");
    }
    return () => {
      if (document.querySelector("[href='/firehouse/view-log']")) {
        document
          .querySelector("[href='/firehouse/view-log']")
          .classList.remove("RaMenuItemLink-active");
      }
    };
  }, []);

  return (
    <>
      <div className="d-flex">
        {step != undefined && <HeaderRoutes step={step} steps={headerLinks} />}
        <div
          style={{
              width: "5px",
          }}
        ></div>
      </div>
    </>
  );
}
